// extracted by mini-css-extract-plugin
export default {"title":"LogoCarousel-module--title--roOvW","itemContainer":"LogoCarousel-module--itemContainer--bTf7a"};